const subscription = {
    limit_exceeded: '您已達到訂閱計劃的限制。',
    get_plan_failed: '無法取得租戶的訂閱計劃。',
    tenant_suspended: '租戶已被暫停。 請聯繫您的管理員。',
};
export default Object.freeze(subscription);
